import Vue from 'vue'
import Router from 'vue-router'
import wxShare from './utils/wxShare'

Vue.use(Router)


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单跳转当前页面报错问题
const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location)
// }

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location)
// }


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) { // 如果savedPosition存在，滚动条会自动跳到记录的值的地方
      return savedPosition
    }
    return { x: 0, y: 0 }// savedPosition也是一个记录x轴和y轴位置的对象
  },
  routes: [
    // 如果URL输入错误或者是URL 匹配不到任何静态资源，就自动跳到到Home页面,也可以指向一个专门的 404 页面   falg为true不展示底部导航
    { path: '*', redirect: '/home', },
    { path: '/WxAuth', name: 'WxAuth', falg: true, component: () => import('./views/WxAuth.vue') },
    { //登录
      path: '/login',
      name: 'login',
      falg: true,
      component: () => import('./views/login/Login.vue')
    },
    // --------------------- loadding
    { //微信綁定 wxbind
      path: '/wxbind',
      name: 'wxbind',
      falg: true,
      component: () => import('./views/login/wxbind.vue')
    },
    { //微信綁定 loadding
      path: '/loading',
      name: 'loading',
      falg: true,
      component: () => import('./views/login/loading.vue')
    },
    // ---------------------
    {//首页
      path: '/home',
      name: 'home',
      component: () => import('./views/home/Home.vue')
    },
    /***********************************数据概况*************************************/
    { //待办事项
      path: '/backlog',
      name: 'backlog',
      component: () => import('./views/message/backlog.vue')
    },
    { //逾期清单
      path: '/overdue',
      name: 'overdue',
      component: () => import('./views/message/overdue.vue')
    },
    { //预警提醒 
      path: '/forewarning',
      name: 'forewarning',
      component: () => import('./views/message/forewarning.vue')
    },
    { //高优先级
      path: '/advanced',
      name: 'advanced',
      component: () => import('./views/message/advanced.vue')
    },
    { //通知管理
      path: '/notice',
      name: 'notice',
      component: () => import('./views/home/notice/notice.vue')
    },
    /************************************审批中心************************************/
    { //审批中心
      path: '/salaryList',
      name: 'salaryList',
      component: () => import('./views/examine/salaryList.vue')
    },
    { //基本资料审批
      path: '/salaryBasic',
      name: 'salaryBasic',
      component: () => import('./views/examine/basic.vue')
    },

    { //基础绩效审批
      path: '/performanceBasic',
      name: 'performanceBasic',
      component: () => import('./views/examine/performance.vue')
    },
    { //基础绩效审批
      path: '/performanceContract',
      name: 'performanceContract',
      component: () => import('./views/examine/contract.vue')
    },
    { //基础绩效审批
      path: '/performanceIncomeTax',
      name: 'performanceIncomeTax',
      component: () => import('./views/examine/incomeTax.vue')
    },
    /************************************项目管理************************************/
    { //项目管理
      path: '/projectList',
      name: 'projectList',
      component: () => import('./views/project/list.vue'),
    },
    { //项目详情
      path: '/projectDetails',
      name: 'projectDetails',
      component: () => import('./views/project/details.vue')
    },
    { //任务管理
      path: '/projectTask',
      name: 'projectTask',
      component: () => import('./views/project/task.vue'),
      meta: {
        keepAlive: true
      }
    },
    { //今日到期
      path: '/projectToday',
      name: 'projectToday',
      component: () => import('./views/project/today.vue')
    },
    { ///任务详情
      path: '/taskDetails',
      name: 'taskDetails',
      component: () => import('./views/project/taskDetails.vue')
    },
    { //成员管理
      path: '/projectMember',
      name: 'projectMember',
      component: () => import('./views/project/member.vue')
    },
    { //成员详情
      path: '/memberDetails',
      name: 'memberDetails',
      component: () => import('./views/project/memberDetails.vue')
    },
    { //合同管理
      path: '/contract',
      name: 'contract',
      component: () => import('./views/project/contract/contract.vue'),
      meta: {
        keepAlive: true
      }
    },
    { //税金配置
      path: '/taxes',
      name: 'taxes',
      component: () => import('./views/project/contract/taxes.vue')
    },
    { //回款管理
      path: '/refund',
      name: 'refund',
      component: () => import('./views/project/contract/refund.vue')
    },
    { //财务管理
      path: '/financeList',
      name: 'financeList',
      component: () => import('./views/performance/finance/list.vue')
    },
    /**************************************绩效管理********************************************/
    { //绩效管理 
      path: '/performanceList',
      name: 'performanceList',
      component: () => import('./views/performance/list.vue'),
      meta: {
        keepAlive: true
      }
    },
    { //绩效详情 
      path: '/performanceDetails',
      name: 'performanceDetails',
      component: () => import('./views/performance/details.vue')
    },
    { //绩效详情 基础绩效 
      path: '/basicsDetails',
      name: 'basicsDetails',
      component: () => import('./views/performance/basicsDetails.vue')
    },
    { //绩效详情 工作绩效 
      path: '/workDetails',
      name: 'workDetails',
      component: () => import('./views/performance/workDetails.vue')
    },
    { //绩效管理 项目奖金
      path: '/bonusDetails',
      name: 'bonusDetails',
      component: () => import('./views/performance/bonus/bonusDetails.vue')
    },
    { //主管评价
      path: '/performanceCharge',
      name: 'performanceCharge',
      component: () => import('./views/performance/evaluate/charge.vue')
    },
    { //公司评价
      path: '/performanceLeader',
      name: 'performanceLeader',
      component: () => import('./views/performance/evaluate/leader.vue')
    },
    { //项目奖金 
      path: '/performanceBonus',
      name: 'performanceBonus',
      component: () => import('./views/performance/bonus/bonus.vue')
    },
    { //新增项目奖金 
      path: '/performanceAddBonus',
      name: 'performanceAddBonus',
      component: () => import('./views/performance/bonus/addBonus.vue')
    },
    { //修改项目奖金 
      path: '/performanceEditBonus',
      name: 'performanceEditBonus',
      component: () => import('./views/performance/bonus/editBonus.vue')
    },
    /*****************************************绩效规则*****************************************/
    { //绩效规则  
      path: '/performanceRule',
      name: 'performanceRule',
      component: () => import('./views/rule/rule.vue')
    },
    { //绩效人员基本设置列表  
      path: '/personnelList',
      name: 'personnelList',
      component: () => import('./views/rule/personnelList.vue')
    },
    { //新增人员设置  
      path: '/addPersonnel',
      name: 'addPersonnel',
      component: () => import('./views/rule/addPersonnel.vue')
    },
    { //编辑人员设置  
      path: '/editPersonnel',
      name: 'editPersonnel',
      component: () => import('./views/rule/editPersonnel.vue')
    },
    { //基础绩效设置
      path: '/settingBasic',
      name: 'settingBasic',
      component: () => import('./views/rule/settingBasic.vue')
    },
    { //个人所得税率设置
      path: '/settingPersonage',
      name: 'settingPersonage',
      component: () => import('./views/rule/settingPersonage.vue')
    },
    { //基础绩效规则说明  
      path: '/basicExplain',
      name: 'basicExplain',
      component: () => import('./views/rule/basicExplain.vue')
    },
    { //维保人员工作绩效规则说明  
      path: '/maintenanceExplain',
      name: 'maintenanceExplain',
      component: () => import('./views/rule/maintenanceExplain.vue')
    },
    { //软件研人员工作绩效规则说明 
      path: '/softwareExplain',
      name: 'softwareExplain',
      component: () => import('./views/rule/softwareExplain.vue')
    },
    { //维保人员工作绩效规则说明  
      path: '/synthesisExplain',
      name: 'synthesisExplain',
      component: () => import('./views/rule/synthesisExplain.vue')
    },
    { //工资导出 
      path: '/wageExprot',
      name: 'wageExprot',
      component: () => import('./views/performance/wage.vue')
    },
    /********************************************************************/ 
    { //记录资料
      path: '/performanceRecords',
      name: 'performanceRecords',
      component: () => import('./views/performance/records.vue')
    },
    { //新增 记录资料
      path: '/performanceRecordsNew',
      name: 'performanceRecordsNew',
      component: () => import('./views/performance/recordsNew.vue')
    },
    {  //我的
      path: '/mine',
      name: 'mine',
      component: () => import('./views/mine/Mine.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      falg: true,
      component: () => import('./views/login/privacy.vue')
    },
  ]
})

// router.beforeEach((to, from, next) => {
//   if (!/micromessenger/i.test(navigator.userAgent)) {
//     next()
//     return
//   }

//   // 不要对 WxAuth 路由进行拦截，不进入 WxAuth 路由就拿不到微信返回的授权 code
//   if (to.name === 'WxAuth') {
//     next()
//     return
//   }

//   const wxUserInfo = localStorage.getItem('wxUserInfo')
//   if (!wxUserInfo) {
//     // 保存当前路由地址，授权后还会跳到此地址
//     sessionStorage.setItem('wxRedirectUrl', to.fullPath)
//     // 请求微信授权,并跳转到 /WxAuth 路由
//     //todo 注意修改 appId 和应用访问 URL
//     let appId = '测试服AppId'
//     let redirectUrl = encodeURIComponent('https://m1.xxxxxx.com/WxAuth')

//     // 判断是否为正式环境
//     if (window.location.origin.indexOf('https://m.xxxxxx.com') !== -1) {
//       appId = '正式服AppId'
//       redirectUrl = encodeURIComponent('https://m.xxxxxx.com/WxAuth')
//     }
//     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
//   } else {
//     next()
//   }
// })



router.afterEach((to) => {
  // 微信分享前初始化 wxConfig
  wxShare.initConfig(`${location.origin}/dc${to.fullPath}`)
})

/****************************修改设置*********************************/



export default router
